
import GalleryBD from '../inner/breadcrumb/GalleryBD'

import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

const images = [
  {
    url: 'assets/images/v2vimages/gallery-5.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-6 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/gallery-1.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/gallery-2.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/gallery-3.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/gallery-4.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },{
    url: 'assets/images/v2vimages/gallery-6.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-6 col-md-6 col-sm-12'
  },

  {
    url: 'assets/images/v2vimages/3.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-6 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/gallery-2-1.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/gallery-2-2.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/gallery-2-3.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/gallery-2-4.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },{
    url: 'assets/images/v2vimages/gallery-02-2.jpg',
    chapter: 'Chapter 1',
    wSize: 'col-lg-6 col-md-6 col-sm-12'
  },
  
 {
    url: 'assets/images/v2vimages/sr3.png',
    chapter: 'Chapter 2',
    wSize: 'col-lg-6 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/sr5.png',
    chapter: 'Chapter 2',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/sr6.png',
    chapter: 'Chapter 2',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/sr7.png',
    chapter: 'Chapter 2',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },
  {
    url: 'assets/images/v2vimages/sr8.png',
    chapter: 'Chapter 2',
    wSize: 'col-lg-3 col-md-6 col-sm-12'
  },{
    url: 'assets/images/v2vimages/sr4.png',
    chapter: 'Chapter 2',
    wSize: 'col-lg-6 col-md-6 col-sm-12'
  },{
    url: 'assets/images/v2vimages/sr1.png',
    chapter: 'Chapter 2',
    wSize: 'col-lg-6 col-md-6 col-sm-12'
  },{
    url: 'assets/images/v2vimages/sr2.png',
    chapter: 'Chapter 2',
    wSize: 'col-lg-6 col-md-6 col-sm-12'
  },   
];


const Gallery = () => {
     
  return (
    <>

  <GalleryBD/> 

    {/* rmp portfolio mesonary area */}
    <div className="tmp-portfolio-area tmp-section-gap">
        <div className="container">
            <div className='row'>
                <div className="col-lg-12">
                    <div className="section-head">
                        <h2 className="title split-collab">Let's Check Our Gallery</h2>
                    </div>
                </div>
            </div>
            <div className='row'>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                        <Col sm={12}>
                            <Nav variant="pills" className="flex-column tmp-mesonary-area-main main-isotop">
                                <Nav.Item className='tmp-button-group mb--50 filters-button-group'>
                                    <Nav.Link className='button' eventKey="first"><span style={{fontSize:'20px'}}>All Chapters</span></Nav.Link>
                                </Nav.Item>

                                <Nav.Item className='tmp-button-group mb--50 filters-button-group'>
                                    <Nav.Link className='button' eventKey="second"><span style={{fontSize:'20px'}}>Chapter1</span></Nav.Link>
                                </Nav.Item>

                                <Nav.Item className='tmp-button-group mb--50 filters-button-group'>
                                    <Nav.Link className='button' eventKey="third"><span style={{fontSize:'20px'}}>Chapter2</span></Nav.Link>
                                </Nav.Item>

                           
                            </Nav>
                        </Col>
                        <Col sm={12}>
                        <Tab.Content>

                            <Tab.Pane eventKey="first">
                                
                                <div className="tmp-portfolio-area tmp-section-gapBottom"  style={{
                                    paddingBottom: '0px',
                                    paddingTop:"40px"
                                    }} >
                                    <div className="container">
                                
                                    

                                        <div className="portfolio-area portfolio-style-three   bg_image bg-image-none">
                                        <div className="container">
                                            <div className="row g-5">

                                                {images.map((item, index) => (
                                
                                                    <div className={item.wSize} key={index}>
                                                        <div className="portfolio-inner">
                                                        <a
                                                        
                                                            className="thumbnail"
                                                            data-tmp-cursor="lg"
                                                            data-tmp-cursor-text="View Details"
                                                        >
                                                            <img
                                                            src={item.url}
                                                            alt={item.chapter}
                                                            />
                                                        </a>
                                                        {/* <div className="portfolio-tag bg-gradiant">
                                                            <div className="content">
                                                            <Link to={"/ProjectDetails"}>
                                                                <h3 className="name animated fadeIn">
                                                            Lorem ipsum dolor 
                                                                </h3>
                                                            </Link>
                                                            <div className="designation"> Lorem ipsum dolor </div>
                                                            </div>
                                                            <Link
                                                            
                                                            className="icon angle-roted border-none bg-color-white"
                                                            >
                                                            <i className="fa-solid fa-arrow-right" />
                                                            </Link>
                                                        </div> */}
                                                        </div>
                                                    </div>
                                                  ))}  
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>

                            </Tab.Pane>
                            
                            <Tab.Pane eventKey="second">

                                <div className="tmp-portfolio-area tmp-section-gapBottom"  style={{
                                    paddingBottom: '0px',
                                    paddingTop:"40px"
                                    }} >
                                    <div className="container">
                                
                                    

                                        <div className="portfolio-area portfolio-style-three   bg_image bg-image-none">
                                        <div className="container">
                                            <div className="row g-5">

                                                {images
                                                .filter(item => item.chapter === 'Chapter 1')
                                                .map((item, index) => (
                                                    <div className={item.wSize} key={index}>
                                                    <div className="portfolio-inner">
                                                        <a
                                                        className="thumbnail"
                                                        data-tmp-cursor="lg"
                                                        data-tmp-cursor-text="View Details"
                                                        >
                                                        <img
                                                            src={item.url}
                                                            alt={item.chapter}
                                                        />
                                                        </a>
                                                        {/* Uncomment if needed
                                                        <div className="portfolio-tag bg-gradiant">
                                                        <div className="content">
                                                            <Link to={"/ProjectDetails"}>
                                                            <h3 className="name animated fadeIn">Lorem ipsum dolor</h3>
                                                            </Link>
                                                            <div className="designation">Lorem ipsum dolor</div>
                                                        </div>
                                                        <Link className="icon angle-roted border-none bg-color-white">
                                                            <i className="fa-solid fa-arrow-right" />
                                                        </Link>
                                                        </div>
                                                        */}
                                                    </div>
                                                    </div>
                                                ))}

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>

                            </Tab.Pane>

                            <Tab.Pane eventKey="third">

                                <div className="tmp-portfolio-area tmp-section-gapBottom"  style={{
                                    paddingBottom: '0px',
                                    paddingTop:"40px"
                                    }} >
                                    <div className="container">
                                
                                    

                                        <div className="portfolio-area portfolio-style-three   bg_image bg-image-none">
                                        <div className="container">
                                            <div className="row g-5">

                                                {images
                                                .filter(item => item.chapter === 'Chapter 2')
                                                .map((item, index) => (
                                                    <div className={item.wSize} key={index}>
                                                    <div className="portfolio-inner">
                                                        <a
                                                        className="thumbnail"
                                                        data-tmp-cursor="lg"
                                                        data-tmp-cursor-text="View Details"
                                                        >
                                                        <img
                                                            src={item.url}
                                                            alt={item.chapter}
                                                        />
                                                        </a>
                                                        {/* Uncomment if needed
                                                        <div className="portfolio-tag bg-gradiant">
                                                        <div className="content">
                                                            <Link to={"/ProjectDetails"}>
                                                            <h3 className="name animated fadeIn">Lorem ipsum dolor</h3>
                                                            </Link>
                                                            <div className="designation">Lorem ipsum dolor</div>
                                                        </div>
                                                        <Link className="icon angle-roted border-none bg-color-white">
                                                            <i className="fa-solid fa-arrow-right" />
                                                        </Link>
                                                        </div>
                                                        */}
                                                    </div>
                                                    </div>
                                                ))}


                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>

                            </Tab.Pane>


                        </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </div>
        </div>
    </div>
    {/* rmp portfolio mesonary area end */}

    </>
  )
}

export default Gallery
